import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalShellComponent } from './modal-shell.component';

@NgModule({
  id: 'modal-shell',
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [
    ModalShellComponent,
  ],
  exports: [
    ModalShellComponent,
  ],
  providers: [],
})

export class ModalShellModule {
}
